import React from 'react';

const VerificationLoadingScreen = () => {
  return (
    <div className="flex items-center justify-center absolute top-0 left-0 w-full h-full bg-white bg-opacity-50 z-50">
      <div className="flex flex-col items-center">
        <div
          className="w-12 h-12 border-4 border-solid rounded-full animate-spin"
          style={{ borderColor: '#e74c3c', borderTopColor: 'transparent' }}
        />
        <p className="mt-4 text-lg font-semibold text-gray-800">
          Verifying real-time inventory. Please wait...
        </p>
      </div>
    </div>
  );
};

export default VerificationLoadingScreen;
